module.exports = __webpack_public_path__ + "img/clearspring.16f51562.jpg";